<template>
  <base-section
    id="contact-us"
    space="56"
  >
    <v-container>
      <v-row justify="space-between">
        <v-col
          cols="12"
          md="5"
        >
          <base-business-contact-info />
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <base-contact-form />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionKeepInTouch',
  }
</script>
